import { GoogleUtmParams } from "../../configs/constants";
import { getParameters } from "../../configs/utils";
import SharedPropsService from "../../SharedPropsService";
export const generateUtmObject = async () => {
    const urlParams = `${await SharedPropsService.getUrlParams()}`.split("?");
    const params = urlParams ? getParameters(await SharedPropsService.getUrlParams()) : {};
    let createUtmObject = {};
    Object.keys(params).forEach((key) => {
        switch (key) {
            case GoogleUtmParams.UTM_CAMPAIGN:
                createUtmObject = {
                    utmCampaign: params[key],
                    ...createUtmObject
                };
                break;
            case GoogleUtmParams.UTM_CONTENT:
                createUtmObject = {
                    utmContent: params[key],
                    ...createUtmObject
                };
                break;
            case GoogleUtmParams.UTM_MEDIUM:
                createUtmObject = {
                    utmMedium: params[key],
                    ...createUtmObject
                };
                break;
            case GoogleUtmParams.UTM_SOURCE:
                createUtmObject = {
                    utmSource: params[key],
                    ...createUtmObject
                };
                break;
            case GoogleUtmParams.UTM_TERM:
                createUtmObject = {
                    utmTerm: params[key],
                    ...createUtmObject
                };
                break;
        }
    });
    return createUtmObject;
};
export const triggerAmplitudeEventCGS = async (instrumentTrack, { eventName, tooltip_num }) => {
    const refUrl = getParameters(window.location.href);
    const sourceQuery = refUrl.source;
    await instrumentTrack(eventName, {
        user_source: sourceQuery === 'PARTNER_DASHBOARD_MFC_CGS' ? 'partner' : 'direct',
        ...tooltip_num && {
            tooltip_num: tooltip_num
        }
    });
};
